import moment from 'moment';

export const convertUnixTimestampToNormalDate = (unixDate: number, dateFormat?: string): string => {
  try {
    return moment.unix(unixDate).format(dateFormat ? dateFormat : 'DD/MM/yyyy');
  } catch (err) {
    return '';
  }
};

export const convertUnixTimestampToInputValue = (unixDate: number): string => {
  try {
    return moment(new Date(convertUnixTimestampToNormalDate(unixDate, 'YYYY/MM/DD'))).format(
      'yyyy-MM-DD'
    );
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalString = (str: string) => {
  try {
    return moment(new Date(str)).format('DD/MM/yyyy');
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalDateTimeString = (str: string) => {
  try {
    return moment(new Date(str)).format('DD/MM/yyyy hh:mm:ss');
  } catch (err) {
    return '';
  }
};

export const convertDateStringToNormalTime = (str: string) => {
  try {
    return moment(new Date(str)).format('hh:mm:ss');
  } catch (err) {
    return '';
  }
};
